import React, { useState, useEffect } from "react";
import styles from "./ModalInstagramIntegrationForm.module.scss";
import Button from "../../ui/Button/Button";
import Title from "../../ui/Title/Title";
import Input from "../../ui/Input/Input";
import InstagramIcon from "../../assets/icons/InstagramIcon";
import VisibleIcon from "../../assets/icons/VisibleIcon";
import HiddenIcon from "../../assets/icons/HiddenIcon";
import { useDispatch, useSelector } from "react-redux";
import { setActiveInst, setNewInst } from "../../store/slices/integrationSlice";
import { ClipLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "../../ui/Modal/Modal";
import { initInst } from "../../utils/api/actions/integrations/instagram";
import { useModal } from "../../context/ModalContext";

const InstagramSuccessMessage = ({ handleCloseModal }) => {
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();
  const location = useLocation();
  const { closeModal } = useModal();

  const externalId = location.pathname.split("/").pop();
  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      handleCloseModal();
      closeModal();
      localStorage.removeItem("typeInstagramInit");
      dispatch(setActiveInst(null));
      dispatch(setNewInst(null));
    }

    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, externalId, id, handleCloseModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили Instagram!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

const ModalInstagramIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);

  const [step, setStep] = useState(1);
  const [userName, setUserName] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [errors, setErrors] = useState({
    userName: "",
    code: "",
    password: "",
  });
  const [isInstagramConnected, setIsInstagramConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const type = localStorage.getItem("typeTelegramInit");

  const nextStep = () => {
    let userData;

    if (step === 1) {
      userData = {
        userId: user.id,
        userName: userName,
        password: password,
        // code: code,
      };
      localStorage.setItem("userName", JSON.stringify(userName));
      dispatch(
        initInst(
          userData,
          setStep,
          setLoading,
          setIsInstagramConnected,
          setError,
          navigate,
          closeModal
        )
      );
    } else if (step === 2) {
      userData = {
        userId: user.id,
        userName: userName,
        password: password,
        code: code,
      };
      dispatch(
        initInst(
          userData,
          setStep,
          setLoading,
          setIsInstagramConnected,
          setError,
          navigate,
          closeModal
        )
      );
    }
  };

  const validateInputs = () => {
    const newErrors = { userName: "", code: "", password: "" };

    if (step === 1 && !userName) {
      newErrors.userName = "Логин не может быть пустым";
    }
    if (step === 1 && !password) {
      newErrors.password = "Пароль не может быть пустым";
    }
    if (step === 2 && code.replace(/[_ ]/g, "").length < 5) {
      newErrors.code = "Код состоит из 6 символов";
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handlerInput = (e) => {
    const { name, value } = e.target;
    if (name === "userName") setUserName(value);
    if (name === "password") setPassword(value);
    if (name === "code") {
      const onlyNumbers = value.replace(/\D/g, "");
      setCode(onlyNumbers.slice(0, 6));
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setErrors({
      ...errors,
      password: newPassword.trim() ? "" : "Поле не может быть пустым",
    });
  };

  const handlerVisiblePassword = () => setVisiblePassword(!visiblePassword);

  // const handleKeyDown = (e) => {
  //     if (
  //         (!errors.userName || !errors.code || !errors.password) &&
  //         e.key === 'Enter'
  //     ) {
  //         nextStep();
  //     }
  // };

  useEffect(() => {
    switch (type) {
      case "login":
        setStep(1);
        break;
      case "code":
        setStep(2);
        break;
      default:
        setStep(1);
        break;
    }
  }, [type]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            {isInstagramConnected ? (
              <InstagramSuccessMessage handleCloseModal={handlerClose} />
            ) : (
              <>
                <div className={styles.inputGroup}>
                  <div className={styles.inputContainer}>
                    <Input
                      className={styles.child}
                      name="userName"
                      label={"Логин"}
                      labelStyle={styles.labelInput}
                      backgroundStyle={styles.labelBackground}
                      inputStyle={`${styles.input}`}
                      value={userName}
                      placeholder={"Ваш никнейм (не e-mail !)"}
                      type={"text"}
                      onChange={handlerInput}
                    />
                  </div>
                  {errors.userName && (
                    <p className={styles.errorText}>{errors.userName}</p>
                  )}
                </div>
                <div className={styles.inputGroup}>
                  <div className={styles.inputContainer}>
                    <Input
                      className={styles.child}
                      name="password"
                      label={"Пароль"}
                      labelStyle={styles.labelInput}
                      backgroundStyle={styles.labelBackground}
                      inputStyle={`${styles.input}`}
                      value={password}
                      placeholder={"Пароль"}
                      type={visiblePassword ? "text" : "password"}
                      rightIcon={
                        visiblePassword ? <VisibleIcon /> : <HiddenIcon />
                      }
                      onClickRightIcon={handlerVisiblePassword}
                      onChange={handlePasswordChange}
                    />
                  </div>
                  {errors.password && (
                    <p className={styles.errorText}>{errors.password}</p>
                  )}
                  {error && <p className={styles.errorText}>{error}</p>}
                </div>
              </>
            )}
          </>
        );
      case 2:
        return (
          <div className={styles.inputGroup}>
            {isInstagramConnected ? (
              <InstagramSuccessMessage handleCloseModal={handlerClose} />
            ) : (
              <div className={styles.inputGroup}>
                <div className={styles.inputContainer}>
                  <Input
                    className={styles.child}
                    name="code"
                    label={"Введите защитный код"}
                    labelStyle={styles.labelInput}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={`${styles.input}`}
                    value={code}
                    placeholder={"6-значный код"}
                    type={"text"}
                    onChange={handlerInput}
                  />
                </div>
                {errors.code && (
                  <p className={styles.errorText}>{errors.code}</p>
                )}
                {error && <p className={styles.errorText}>{error}</p>}
              </div>

              // <>
              //     <div className={styles.inputGroupTitle}>
              //         Введите код
              //     </div>
              //     <div className={styles.inputContainer}>
              //         {['', '', '', '', ''].map((_, index) => (
              //             <Input
              //                 key={`input-code-${index}`}
              //                 className={styles.child}
              //                 labelStyle={styles.labelInput}
              //                 backgroundStyle={
              //                     styles.labelBackground
              //                 }
              //                 inputStyle={`${styles.inputCode} ${
              //                     index === activeInputIndex
              //                         ? styles.active
              //                         : ''
              //                 }`}
              //                 name="name"
              //                 maxLength="1"
              //                 value={code[index] || ''}
              //                 refFocus={(el) =>
              //                     (inputRefs.current[index] = el)
              //                 }
              //                 onChange={(e) =>
              //                     handleInputChange(e, index)
              //                 }
              //                 type={'text'}
              //             />
              //         ))}
              //     </div>
              //     {errors.code && (
              //         <p className={styles.errorText}>
              //             {errors.code}
              //         </p>
              //     )}
              //     {error && (
              //         <p className={styles.errorText}>{error}</p>
              //     )}
              // </>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Modal visible={visible} handleClose={handlerClose}>
      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <InstagramIcon size={25} />
        </div>

        <div className={styles.content}>
          <div className={styles.steps}>
            {[1, 2].map((stepNumber, index) => (
              <React.Fragment key={stepNumber}>
                <div
                  className={`${styles.step} ${
                    stepNumber === step ? styles.active : ""
                  }`}
                >
                  {stepNumber}
                </div>
                {index < 1 && (
                  <div className={styles.dashedLine}>
                    {stepNumber < step && (
                      <div className={styles.completedContainer}>✓</div>
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className={styles.body}>
            {renderStep()}
            {step < 3 && !isInstagramConnected ? (
              <Button
                title="Далее"
                onClick={() => (validateInputs() ? nextStep() : undefined)}
                className={styles.nextButton}
                titleClassName={styles.nextButtonTitle}
                leftIcon={
                  loading ? <ClipLoader size={20} color="white" /> : null
                }
              />
            ) : (
              !isInstagramConnected && (
                <Button
                  title="Отправить"
                  onClick={() => (validateInputs() ? nextStep() : undefined)}
                  className={styles.nextButton}
                  titleClassName={styles.nextButtonTitle}
                  leftIcon={
                    loading ? <ClipLoader size={20} color="white" /> : null
                  }
                />
              )
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalInstagramIntegrationForm;
